<template>
<div>
  <b-card :title="entities[$route.params.json]"
          tag="article">
    <template v-for="(item, index) in metafilter">
      <FormComponent :metadata='item' :dbfield='metanames[index]' :key='"comp_"+index'
        v-model="filter[metanames[index]]" :isSearch="true" />
    </template>
    <b-row>
      <b-col cols="auto" class="mr-auto p-3">
        <b-button variant="primary" @click="addData()">Agregar</b-button>
        <b-button v-if="false" variant="primary" @click="test()">test {{testx}}</b-button>
      </b-col>
      <b-col v-if="$route.params.typex=='local'" cols="auto" class="p-3">
        <input type="checkbox" id="syncronize1" v-model="send">
        <label for="syncronize1">Enviar al Servidor</label>
      </b-col>
    </b-row>
  </b-card>
  <b-alert variant="info" :show="msg != null">{{msg}}</b-alert>
  <b-progress v-if="$route.params.typex=='local'" :max="total" height="2rem">
    <b-progress-bar :value="avance" v-if="!msg">
      Avance: <strong>{{ avance }} / {{ total }}</strong>
    </b-progress-bar>
  </b-progress>
  <b-table :stacked="$route.params.typex === 'local'" striped hover :items="list" :fields="fields"
    :sort-compare="sortCompare" :sort-by.sync="order" :sort-desc.sync="desc" responsive="sm">
    <template v-slot:cell(options)="data">
      <b-spinner label="Cargando..." v-if="!('permission' in data.item)"></b-spinner>
      <template v-else>
        <router-link v-if="data.item.permission.view" class="btn btn-info"
          :to="{ name: $route.params.json + '_view', params: { typex: $route.params.typex, json: $route.params.json, id: data.item._id } }">
          Ver
        </router-link>
        &nbsp;
        <router-link v-if="data.item.permission.edit" class="btn btn-info"
          :to="{ name: 'form', params: { typex: $route.params.typex, json: $route.params.json, id: data.item._id } }">
          Modificar
        </router-link>
        &nbsp;
        <b-button v-if="data.item.permission.delete" variant="danger" @click="deleteData(data.item,true)">Eliminar</b-button>
      </template>
    </template>
  </b-table>
  <button v-if="more" @click="loadMore()" :disabled="isBusy">Cargar mas</button>
</div>
</template>
<script>
import Base from './Base.vue'
import { mapState, mapActions } from 'vuex'
import FormComponent from './FormComponents/FormComponent.vue'
import Vue from 'vue'

export default {
  extends: Base,
  components: {
    FormComponent
  },
  data () {
    return {
      list: [],
      fields: [],
      metafilter: [],
      metajoined: [],
      metanames: [],
      filter: {},
      send: false,
      current: null,
      total: 0,
      avance: 0,
      selector: null,
      bookmark: null,
      pageSize: 10,
      curpage: 0,
      isBusy: false,
      order: null,
      desc: false,
      more: true,
      testx: 0
    }
  },
  mounted () {
    var obj = this
    window.onscroll = () => {
      if (this.$route.name === 'list') {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          obj.loadMore()
        }
      }
    }
  },
  watch: {
    current (to, from) {
      if (this.send) {
        if (to) {
          this.replicateCurrent()
        } else {
          this.newCurrent()
        }
      }
    },
    db (to, from) {
      this.loadFilter()
      this.loadHeader()
      if (to) {
        this.loadList()
      } else {
        this.clearList()
      }
    },
    send (to, from) {
      let obj = this
      if (to) {
        if (obj.msg) {
          obj.send = false
        } else {
          obj.total = 0
          obj.newCurrent()
        }
      } else {
        obj.loadList()
      }
    },
    filter: {
      handler: function (to) {
        this.loadList()
      },
      deep: true
    },
    msg (to) {
      this.send = false
    },
    order (to) {
      this.loadList()
    },
    desc (to) {
      this.loadList()
    },
    $route (to, from) {
      this.order = null
      this.desc = false
    }
  },
  computed: {
    ...mapState([
      'entities',
      'user'
    ])
  },
  methods: {
    ...mapActions([
      'get_db',
      'setMessage'
    ]),
    sortCompare (a, b, c) {
      return 0
    },
    replicateCurrent () {
      let obj = this
      this.replicate(obj.current).then(function () {
        obj.avance += 1
        obj.current = null
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('replicateCurrent: ' + JSON.stringify(err))
      })
    },
    newCurrent () {
      let obj = this
      var search = {
        selector: {
          $and: [
            { _id: { $ne: '_design/app' } },
            { _id: { $ne: '_design/index' } },
            { synced: { $exists: false } }
          ]
        }
      }
      obj.db.find(search).then(function (list) {
        if (list.docs.length) {
          if (obj.total === 0) {
            obj.total = list.docs.length
            obj.avance = 0
          }
          obj.$set(obj, 'current', list.docs[0])
        } else {
          obj.send = false
        }
      })
    },
    eachRecursive (index, joinedindex, obj, func) {
      for (var k in obj) {
        if (typeof obj[k] === 'object' && obj[k] !== null) {
          this.eachRecursive(k, joinedindex + '.' + k, obj[k], func)
          func(k, joinedindex + '.' + k, obj[k], true)
        } else {
          func(k, joinedindex + '.' + k, obj[k], false)
        }
      }
    },
    loadFilter () {
      var obj = this
      obj.metafilter = []
      obj.metanames = []
      this.eachRecursive('', '', obj.metadata, function (metaname, joinedname, elem, isobject) {
        if (isobject && elem.search) {
          obj.metanames.push(metaname)
          obj.metajoined.push(joinedname.substr(1).replace(/.children/g, '').replace(/.choices.[0-9]/g, ''))
          obj.metafilter.push(elem)
        }
      })
    },
    loadHeader () {
      let fields = []
      /* let fields = [{
        key: '_id',
        label: 'id',
        sortable: true,
        order: true
      }] */
      var obj = this
      this.eachRecursive('', '', this.metadata, function (metaname, joinedname, met, isobject) {
        if (isobject && met.list) {
          var elem = {
            // parche: replace choices.0 debería remplazar dinamicamente
            key: joinedname.substr(1).replace(/.children/g, '').replace(/.choices.[0-9]/g, ''),
            label: met.label,
            sortable: true,
            order: met.list
          }
          if (met.type === 'choice') { elem.formatter = obj.formatter(met) }
          if (met.type === 'choicexchoice') { elem.formatter = obj.formatterchoicexchoice(met) }
          if (met.listformat === 'date') { elem.formatter = obj.formatterDate }
          fields.push(elem)
        }
      })
      fields.sort(function (a, b) { return a.order - b.order })
      fields.push({
        key: 'options',
        label: 'Opciones',
        sortable: false
      })
      // console.log(fields)
      this.$set(this, 'fields', fields)
      // this.fields = fields
    },
    clearList () {
      this.$set(this, 'list', [])
    },
    loadList () {
      let obj = this
      obj.isBusy = true
      // obj.db = obj.get_db()
      if (!obj.db) { return }
      var selector = {
        $and: [
          { _id: { $ne: '_design/app' } },
          { _id: { $ne: '_design/index' } }
        ]
      }
      if (obj.$route.params.typex === 'local') {
        selector['$and'].push({ synced: { $exists: false } })
      }
      for (var i in obj.metafilter) {
        if (obj.metanames[i] in obj.filter) {
          if (obj.metafilter[i].search.stype === 'range') {
            var partialfilter = {}
            partialfilter[obj.metajoined[i]] = {}
            if (obj.filter[obj.metanames[i]].start && obj.filter[obj.metanames[i]].start !== '') {
              partialfilter[obj.metajoined[i]]['$gte'] = obj.filter[obj.metanames[i]].start
            }
            if (obj.filter[obj.metanames[i]].end && obj.filter[obj.metanames[i]].end !== '') {
              partialfilter[obj.metajoined[i]]['$lte'] = obj.filter[obj.metanames[i]].end
            }
            if (!((!obj.filter[obj.metanames[i]].start || obj.filter[obj.metanames[i]].start === '') &&
              (!obj.filter[obj.metanames[i]].end || obj.filter[obj.metanames[i]].end === ''))) {
              if (obj.filter[obj.metanames[i]].end >= obj.filter[obj.metanames[i]].start) {
                selector['$and'].push(partialfilter)
              }
            }
          } else if (obj.metafilter[i].search.stype === 'choicexchoice') {
            if (obj.filter[obj.metanames[i]]) {
              partialfilter = {}
              partialfilter[obj.metajoined[i] + '.' + obj.metafilter[i].select_index] = {
                $eq: obj.filter[obj.metanames[i]][obj.metafilter[i].select_index]
              }
              if (obj.filter[obj.metanames[i]][obj.metafilter[i].choices[0].select_index]) {
                partialfilter[obj.metajoined[i] + '.' + obj.metafilter[i].choices[0].select_index] = {
                  $eq: obj.filter[obj.metanames[i]][obj.metafilter[i].choices[0].select_index]
                }
              }
              selector['$and'].push(partialfilter)
            }
          } else if (obj.metafilter[i].search.stype === 'exists') {
            if (obj.filter[obj.metanames[i]]) {
              if (obj.filter[obj.metanames[i]].includes('si')) {
                if (!obj.filter[obj.metanames[i]].includes('no')) {
                  partialfilter = {}
                  partialfilter[obj.metajoined[i]] = {
                    $exists: true
                  }
                  selector['$and'].push(partialfilter)
                  partialfilter = {}
                  partialfilter[obj.metajoined[i]] = {
                    $ne: ''
                  }
                  selector['$and'].push(partialfilter)
                }
              } else if (obj.filter[obj.metanames[i]].includes('no')) {
                var elem = {}
                elem['$or'] = []
                partialfilter = {}
                partialfilter[obj.metajoined[i]] = {
                  $exists: false
                }
                elem['$or'].push(partialfilter)
                partialfilter = {}
                partialfilter[obj.metajoined[i]] = {
                  $eq: ''
                }
                elem['$or'].push(partialfilter)
                selector['$and'].push(elem)
              }
            }
          } else {
            partialfilter = {}
            partialfilter[obj.metajoined[i]] = {
              $eq: obj.filter[obj.metanames[i]]
            }
            if (obj.filter[obj.metanames[i]] !== '' && obj.filter[obj.metanames[i]] !== null) {
              selector['$and'].push(partialfilter)
            }
          }
        }
      }
      obj.$set(obj, 'selector', selector)
      obj.$set(obj, 'bookmark', null)
      var search = {
        selector: obj.selector,
        limit: obj.pageSize
      }
      if (obj.order) {
        search.sort = [{}]
        search.sort[0][obj.order] = obj.desc ? 'desc' : 'asc'
      }
      obj.db.find(search).then(function (list) {
        /* parche */
        for (var i = 0; i < list.docs.length; i++) {
          if (list.docs[i].identification &&
            list.docs[i].identification.platform && list.docs[i].identification.platform !== '') {
            list.docs[i].identification.flowline = list.docs[i].identification.platform
            list.docs[i].identification.progressive = list.docs[i].identification.instalation
            list.docs[i].identification.side_to_ddv = list.docs[i].identification.talud
          }
        }
        /* ********* */
        obj.$set(obj, 'list', list.docs)
        if (list.docs.length < obj.pageSize) {
          obj.more = false
        } else {
          obj.more = true
        }
        obj.isBusy = false
        obj.getPermission(0)
        obj.$set(obj, 'bookmark', list.bookmark)
        obj.$set(obj, 'curpage', 0)
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('loadList: ' + JSON.stringify(err))
      })
    },
    loadMore () {
      var obj = this
      if (!obj.db.find || obj.isBusy) {
        return
      }
      obj.isBusy = true
      var search = {}
      if (obj.bookmark) {
        search = {
          selector: obj.selector,
          bookmark: obj.bookmark,
          limit: obj.pageSize
        }
      } else {
        search = {
          selector: obj.selector,
          limit: obj.pageSize,
          skip: (obj.curpage + 1) * obj.pageSize
        }
      }
      if (obj.order) {
        search.sort = [{}]
        search.sort[0][obj.order] = obj.desc ? 'desc' : 'asc'
      }
      obj.db.find(search).then(function (list) {
        // console.log(list)
        /* parche */
        for (var i = 0; i < list.docs.length; i++) {
          if (list.docs[i].identification.platform && list.docs[i].identification.platform !== '') {
            list.docs[i].identification.flowline = list.docs[i].identification.platform
            list.docs[i].identification.progressive = list.docs[i].identification.instalation
            list.docs[i].identification.side_to_ddv = list.docs[i].identification.talud
          }
        }
        /* ********* */
        var num = obj.list.length
        obj.list.push(...list.docs)
        if (list.docs.length < obj.pageSize) {
          obj.more = false
        } else {
          obj.more = true
        }
        obj.getPermission(num)
        obj.$set(obj, 'bookmark', list.bookmark)
        if (list.docs.length) {
          obj.curpage += 1
        }
        obj.isBusy = false
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('loadMore: ' + JSON.stringify(err))
        obj.isBusy = false
      })
    },
    getPermission (num) {
      var obj = this
      var i
      if (obj.$route.params.typex === 'local') {
        for (i = num; i < obj.list.length; i++) {
          obj.list[i].permission = {
            'view': true,
            'edit': true,
            'delete': true
          }
        }
      } else {
        var ids = []
        for (i = num; i < obj.list.length; i++) {
          ids.push(obj.list[i]._id)
        }
        this.dbconfig.get('config').then(function (config) {
          // var url = config.server + '/' + obj.$route.params.json + '/_design/app/_list/permission/permission'
          var url = obj.db.name + '/_design/app/_list/permission/permission'
          Vue.http.get(url, {
            withCredentials: true,
            params: {
              include_docs: true,
              keys: JSON.stringify(ids)
            }
          }).then(
            function (msj) {
              for (i = num; i < num + msj.body.length; i++) {
                obj.$set(obj.list[i], 'permission', msj.body[i - num].permission)
              }
              // obj.$set(obj, 'list', obj.list)
            },
            function (err) {
              console.log(err)
              if ('message' in err) {
                obj.msg = err.message
              } else {
                obj.msg = err.toString()
              }
              obj.setMessage('getPermission: ' + JSON.stringify(err))
            }
          )
        })
      }
    },
    addData () {
      this.$router.push({ name: 'form', params: { typex: this.$route.params.typex, json: this.$route.params.json, id: 0 } })
    },
    modifyData (data) {
      this.$router.push({ name: 'form', params: { typex: this.$route.params.typex, json: this.$route.params.json, id: data._id } })
    },
    viewData (data) {
      this.$router.push({ name: this.$route.params.json + '_view', params: { typex: this.$route.params.typex, json: this.$route.params.json, id: data._id } })
    },
    deleteData (val, warn) {
      var obj = this
      if (warn) {
        this.$dialog.confirm('Seguro que desea eliminar el registro ?', { okText: 'Eliminar', cancelText: 'Cancelar' })
          .then(function () {
            obj.deleteData2(val)
          }).catch(function () {
            console.log('Clicked on cancel')
          })
      } else {
        obj.deleteData2(val)
      }
    },
    deleteData2 (val) {
      let obj = this
      this.deletedata(val).then(function () {
        obj.loadList()
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('deleteData2: ' + JSON.stringify(err))
      })
    },
    formatter (met) {
      let choices = {}
      for (var i in met.choices) {
        choices[met.choices[i].value] = met.choices[i].display_name
      }
      /* parche */
      if (this.$route.params.json === 'inspection' && met.label === 'Flowline') {
        this.metadata.identification.choices[1].children.platform.choices.forEach(function (elem) {
          choices[elem.value] = 'Plat. ' + elem.display_name
        })
      }
      if (this.$route.params.json === 'inspection' && met.label === 'Lado a DdV') {
        this.metadata.identification.choices[1].children.talud.choices.forEach(function (elem) {
          choices[elem.value] = elem.display_name
        })
      }
      /* *************** */
      return function (val) {
        return choices[val]
      }
    },
    formatterchoicexchoice (met) { // TODO: choices[0] debería ser acorde a la eleccion
      let choices = {}
      let choices2 = {}
      for (var i in met.choices) {
        choices[met.choices[i].value] = met.choices[i].display_name
        for (var j in met.choices[i].choices) {
          choices2[met.choices[i].choices[j].value] = met.choices[i].choices[j].display_name
        }
      }
      return function (val) {
        return choices[val[met.select_index]] + ' [' + choices2[val[met.choices[0].select_index]] + ']'
      }
    },
    formatterDate (val) {
      var d1 = new Date()
      var d = new Date(parseInt(val) - d1.getTimezoneOffset() * 60000)
      d = d.toISOString()
      return d.substr(0, 10) + ' ' + d.substr(11, 5)
    },
    test () {
      // codigo para cambiar registros de la bd
      /* var obj = this
      var input = []
      var f = function (db, j) {
        db.get(input[j][0]).then(function (elem) {
          elem.username = input[j][1]
          db.put(elem).then(function () {
            console.log('funciona ' + j)
          }).catch(function (err) {
            console.log(err)
          })
        }).catch(function (err) {
          console.log(err)
        })
      }
      obj.get_db({json:'_users'}).then(function (db) {
        for (var i = 0; i < input.length; i++) {
          db.put(input[i]).then(function () {
            console.log('funciona ' + i)
          }).catch(function (err) {
            console.log(err)
          })
        }
      }) */
      /* obj.get_db().then(function (db) {
        db.allDocs({
          limit: 1000,
          include_docs: true
        }).then(function (docs) {
          for (var row in docs.rows) {
            var doc = docs.rows[row].doc
            if ('identification' in doc && 'flowline' in doc.identification && doc.identification.flowline === 'u600') {
              //////////////////////////////
              /* doc.identification.progressive = parseInt(doc.identification.progressive)
              db.put(doc).then(function (aa) {
                console.log(aa)
                obj.testx += 1
              }).catch(function (err) {
                console.log(doc)
                console.log(err)
              })
              ////////////////////
              db.remove(doc).then(function (aa) {
                console.log(aa)
                obj.testx += 1
              }).catch(function (err) {
                console.log(doc)
                console.log(err)
              })
            }
          }
        })
      }) */
    }
  }
}
</script>
